// 雷石简版点歌台相关页面

export default [
  {
    path: '/thunder/simple_home',
    name: 'simple_index',
    component: () => import('@/views/simple_index/simple_index'),
    meta: {
      title: '首页',
    },
  },
  {
    path: '/thunder/simple_ordered',
    name: 'simple_ordered',
    component: () => import('@/views/simple_ordered/simple_ordered'),
    meta: {
      title: '已点',
    },
  },
];
